import "./Footer.css";
import useFetch from "../hooks/useFetch";
import config from "../config";

const Footer = () => {
  const { loading, error, data } = useFetch(
    `${config.api}/api/footer?populate=*`
  );

  if (loading) return <p>Loading...</p>;
  if (error) return <p> </p>;

  //? test
  //? console.log("footer", data);

  return (
    <>
      <footer className="container-fluid d-flex flex-column flex-lg-row justify-content-center footer-background">
        <div className="container">
          <div className="row d-flex">
            <h2 className="pt-4 text-center">{data.data.title}</h2>
            <div className="col-lg-4 text-center p-3 order-1 order-lg-1">
              <p className="text-justify">{data.data.text}</p>
              <br />
              {data.data.sponsors.map((sponsor) => (
                <img
                  key={sponsor.id}
                  src={`${config.api}${sponsor.url}`}
                  alt={sponsor.alternativeText}
                  className="col-6 p-2 footer-img"
                />
              ))}
            </div>
            <div className="col-lg-4 d-flex flex-column text-center align-items-center justify-content-center order-3 order-lg-2">
              <img
                src={`${config.api}${data.data.image.url}`}
                alt={data.data.image.alternativeText}
                className="col-lg-8 col-6 pb-3"
              />
              <p className="pb-3">
                <b>{data.data.imageTitle}</b>
              </p>
            </div>
            <div className="col-lg-4 d-flex flex-column text-center align-items-center justify-content-center order-2 order-lg-3 pb-3">
              <div className="d-flex flex-column flex-md-row flex-lg-column justify-content-evenly align-items-center flex-wrap w-100">
                {data.data.contacts.map((contact) => (
                  <div key={contact.id} className="footer-contact m-2">
                    <h3>
                      <b>
                        {contact.prefix} {contact.firstname} {contact.lastname}{" "}
                        {contact.suffix}
                      </b>
                    </h3>
                    <p>
                      {contact.position}
                      {contact.phone !== null && (
                        <>
                          <br />
                          <b> {contact.phone}</b>
                        </>
                      )}
                      <br />
                      <b> {contact.email}</b>
                      <br />
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
export default Footer;

